import { Grid } from '@mui/material';
import OrderChannelsDashboard from './OrderChannelsDashboard';
import OrdersSyncDashboard from './OrdersSyncDashboard';
import ProductsInventoryDashboard from './ProductsInventoryDashboard';

let Dashboard = () => {
    return (
        <>
            <Grid item xs={12}>
                <OrdersSyncDashboard />
            </Grid>
            <Grid item xs>
                <OrderChannelsDashboard />
            </Grid>
            <Grid item xs>
                <ProductsInventoryDashboard />
            </Grid>
        </>
    )
}

export default Dashboard;